import {
    FETCH_AQI,
    FETCH_HISTORIC_AQI,
    REMOVE_AQI,
    SAVE_TIMEOUT,
    STOP_TIMEOUT
} from "../../actions/analytics";

const initialState = {
    aqi: null,
    historic: {
        aqi: null,
        time: null,
    },
    timeout: null,
}

const analytics = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_AQI:
            return {
                ...state,
                aqi: action.aqi
            }

        case FETCH_HISTORIC_AQI:
            let time = []
            let aqi = []
            action.historic.forEach(data => {
                // const date = new Date(data.timestamp)
                // const minutes = ("0" + date.getMinutes()).substr(-2)
                // const hours = ("0" + date.getHours()).substr(-2)
                // time.push(hours + ":" + minutes)
                time.push(data.timestamp)
                aqi.push(data.value)
            })
            return {
                ...state,
                historic: {
                    aqi,
                    time
                }
            }

        case REMOVE_AQI:
            return {
                ...state,
                aqi: null

            }

        case SAVE_TIMEOUT:
            return {
                ...state,
                timeout: action.timeout
            }

        case STOP_TIMEOUT:
            if(state.timeout) clearTimeout(state.timeout)
            return {
                ...state,
                timeout: null
            }
        default:
            return state
    }
}

export default analytics



// WEBPACK FOOTER //
// ./src/reducers/map/analytics.js